export const contacts = (state) => state.contacts
